import React from 'react'
import { ImageContainer, SectionImage } from '../styles/components'

const ImgSectionTx = () => {
  return (
   <ImageContainer>
    <SectionImage src='/images/landingpagev2/Section.png' alt='Woman looking at smartphone' />
   </ImageContainer>
  )
}

export default ImgSectionTx